import * as React from 'react';
import {
  Box,
  Alert,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Button,
  Chip
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { CButton } from '../../../../components/common/Modal';
import { CubeTable } from './CubeTable';

export const OracleEPMCubesStep = ({
  cubes,
  availableDimensions,
  loadedCubes,
  cubeSaveLoading,
  cubeSaveResult,
  isValid,
  onAddCube,
  onCubeNameChange,
  onDimensionToggle,
  onRemoveCube,
  onSaveCubes,
  onBack
}) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'medium' }}>
          Setup Cubes
          {loadedCubes.length > 0 && (
            <Chip 
              label={`${loadedCubes.length} Cubes Loaded`} 
              size="small" 
              color="success" 
              sx={{ ml: 2 }} 
            />
          )}
        </Typography>
                      
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
          <Button 
            variant="outlined" 
            size="small"
            startIcon={<AddIcon />}
            onClick={onAddCube}
            disabled={availableDimensions.length === 0}
          >
            Add Cube
          </Button>
        </Box>
        
        <CubeTable
          cubes={cubes}
          availableDimensions={availableDimensions}
          onCubeNameChange={onCubeNameChange}
          onDimensionToggle={onDimensionToggle}
          onRemoveCube={onRemoveCube}
        />
        
        {cubes.length === 0 && availableDimensions.length > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
            No cubes configured. Click "Add Cube" to create your first cube.
          </Typography>
        )}
        
        {availableDimensions.length === 0 && (
          <Alert severity="info" sx={{ mt: 2 }}>
            <Typography variant="body2">
              No dimensions available. Please complete the Oracle EPM Configuration step and sync metadata to load available dimensions.
            </Typography>
          </Alert>
        )}
        
        {cubeSaveResult && (
          <Alert 
            severity={cubeSaveResult.success ? "success" : "error"} 
            sx={{ marginTop: '1rem' }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              {cubeSaveResult.message}
            </Typography>
            {cubeSaveResult.errors && cubeSaveResult.errors.length > 0 && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="caption" sx={{ fontWeight: 'medium', display: 'block', mb: 0.5 }}>
                  Errors:
                </Typography>
                <Box component="ul" sx={{ margin: 0, paddingLeft: 2 }}>
                  {cubeSaveResult.errors.map((error, index) => (
                    <Typography key={index} variant="caption" component="li" sx={{ display: 'block', mb: 0.5 }}>
                      {error}
                    </Typography>
                  ))}
                </Box>
              </Box>
            )}
          </Alert>
        )}
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <CButton
            variant="outlined"
            onClick={onBack}
          >
            Back
          </CButton>
          <CButton
            variant="contained"
            onClick={onSaveCubes}
            disabled={!isValid || cubeSaveLoading}
            startIcon={cubeSaveLoading ? <CircularProgress size={16} /> : null}
          >
            {cubeSaveLoading ? 'Saving...' : 'Save and Finish'}
          </CButton>
        </Box>
      </CardContent>
    </Card>
  );
};

